export const BASE_AMOUNT_TYPES_ALIASES = {
  MONTHLY: 'MONTHLY',
  HOURLY: 'HOURLY',
  FIXED: 'FIXED',
  MONTHLY_NO_OVERRATES: 'MONTHLY_NO_OVERRATES',
  HOURLY_NO_OVERRATES: 'HOURLY_NO_OVERRATES',
};

export const BASE_AMOUNT_TYPES = {
  MONTHLY: 'Monthly',
  HOURLY: 'Hourly',
  FIXED: 'Fixed',
  MONTHLY_NO_OVERRATES: 'Monthly no overrates',
  HOURLY_NO_OVERRATES: 'Hourly no overrates',
};
